import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useRecaptcha } from '@grandvisionhq/forms';

const getName = (formState)=>{
    var ref, ref1;
    const firstName = ((ref = formState.firstName) === null || ref === void 0 ? void 0 : ref.value) || '';
    const lastName = ((ref1 = formState.lastName) === null || ref1 === void 0 ? void 0 : ref1.value) || '';
    return `${firstName} ${lastName}`.trim();
};
const getReason = (formState)=>{
    var ref;
    const data = (ref = formState['topic-list']) === null || ref === void 0 ? void 0 : ref.value;
    if (data && data.key) {
        return data.key;
    }
    return '';
};
const useSubmit = ()=>{
    const [data, setData] = React.useState(undefined);
    const { getToken  } = useRecaptcha();
    const onSubmit = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*({ formState , formValid  }) {
            try {
                const token = yield getToken();
                if (formValid) {
                    var ref, ref2, ref3, ref4;
                    setData({
                        recaptchaToken: token,
                        ticketInput: {
                            name: getName(formState),
                            email: ((ref = formState.email) === null || ref === void 0 ? void 0 : ref.value) || '',
                            phoneNumber: ((ref2 = formState.phone) === null || ref2 === void 0 ? void 0 : ref2.value) || '',
                            customerID: ((ref3 = formState.customerID) === null || ref3 === void 0 ? void 0 : ref3.value) || '',
                            subject: '',
                            description: ((ref4 = formState.description) === null || ref4 === void 0 ? void 0 : ref4.value) || '',
                            reason: getReason(formState)
                        }
                    });
                }
            } catch (error) {
                console.error('Recaptcha', error);
            }
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    const reset = React.useCallback(()=>{
        setData(undefined);
    }, []);
    const actions = React.useMemo(()=>({
            onSubmit,
            reset
        })
    , [
        onSubmit,
        reset
    ]);
    return [
        data,
        actions
    ];
};

export { useSubmit };
//# sourceMappingURL=use-submit.js.map
